import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { ResetPasswordPageComponent } from './reset-password-page.component';
import { FormsModule } from '@angular/forms';
import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'resetPassword',
    url: '/setpassword',
    component: ResetPasswordPageComponent,
    data: {
      requireLogin: false
    },
    params: {
      message: null
    }
  }
];

@NgModule({
  declarations: [ResetPasswordPageComponent],
  imports: [
    CommonModule, FormsModule, SkeletonLoaderModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [ResetPasswordPageComponent],
})
export class ResetPasswordPageModule { }
